import BaseAPI from './base'

/**
 * API xử lí bài kiểm tra
 */

class StudentExamAPI extends BaseAPI {}

export default new StudentExamAPI('v1/student-exam', 'StudentExam')
